module.exports = __webpack_public_path__ + "static/media/SuccessIcon.2ebf3a0b.svg";